/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * RakeBack Wizard API
 * OpenAPI spec version: 1.0.0
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query'

import type { SiteSettings } from '../models'

import siteSettingsRetrieveMutator from '../../client'

/**
 * API view to retrieve the site-wide settings.
This is a singleton object, so it does not take a pk.
 */
export const siteSettingsRetrieve = (signal?: AbortSignal) => {
  return siteSettingsRetrieveMutator<SiteSettings>({
    url: `/api/v1/site-settings/`,
    method: 'GET',
    signal,
  })
}

export const getSiteSettingsRetrieveQueryKey = () => {
  return [`/api/v1/site-settings/`] as const
}

export const getSiteSettingsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof siteSettingsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof siteSettingsRetrieve>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getSiteSettingsRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof siteSettingsRetrieve>>> = ({ signal }) =>
    siteSettingsRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof siteSettingsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteSettingsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof siteSettingsRetrieve>>
>
export type SiteSettingsRetrieveQueryError = unknown

export function useSiteSettingsRetrieve<
  TData = Awaited<ReturnType<typeof siteSettingsRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof siteSettingsRetrieve>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof siteSettingsRetrieve>>,
        TError,
        Awaited<ReturnType<typeof siteSettingsRetrieve>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteSettingsRetrieve<
  TData = Awaited<ReturnType<typeof siteSettingsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof siteSettingsRetrieve>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof siteSettingsRetrieve>>,
        TError,
        Awaited<ReturnType<typeof siteSettingsRetrieve>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteSettingsRetrieve<
  TData = Awaited<ReturnType<typeof siteSettingsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof siteSettingsRetrieve>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSiteSettingsRetrieve<
  TData = Awaited<ReturnType<typeof siteSettingsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof siteSettingsRetrieve>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSiteSettingsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getSiteSettingsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof siteSettingsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof siteSettingsRetrieve>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getSiteSettingsRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof siteSettingsRetrieve>>> = ({ signal }) =>
    siteSettingsRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof siteSettingsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteSettingsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof siteSettingsRetrieve>>
>
export type SiteSettingsRetrieveSuspenseQueryError = unknown

export function useSiteSettingsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof siteSettingsRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof siteSettingsRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteSettingsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof siteSettingsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof siteSettingsRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteSettingsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof siteSettingsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof siteSettingsRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSiteSettingsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof siteSettingsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof siteSettingsRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSiteSettingsRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}
